export const MIN_NAME_TRAINING_CENTER_LENGTH = 1;
